// extracted by mini-css-extract-plugin
export default {"button":"_3PGu6 dim-button","menu":"_2o9yZ","menuItem":"_2fVYm","highlighted":"nDGEs","disabled":"_3s6PK","kebabButton":"_36AHv _22cZA","separator":"_2neIZ","arrow":"_2y6E4"};